// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__FgsWJ","active":"NavigationItem_active__161Kz"};